module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAMBAMAAABYTmoeAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAALVBMVEUAAADo5Obo5Obo5Obo5Obo5Obo5Obo5Obo5Obo5Obo5Obo5Obo5Obo5Obo5OZItticAAAADnRSTlMAaUL5JO0P2AO6k5S72bCpdYEAAAABYktHRACIBR1IAAAACXBIWXMAAAsSAAALEgHS3X78AAAALklEQVQI12NgYBBgYGAyYGBwfcDAVveAofPdA4Z1QLwPiHuAmO3eA7AcWA2DAABvwg+wVkY1pgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ../server/public/static/images/global/type-arrows/left-grey2.png
// module id = 780
// module chunks = 0 1 2 3 4